import ContactListBase from "./ContactListBase";


export default function BusinessPartnerList() {
    return <ContactListBase title="Sócios" endpoint="contacts/" defaultType="BUSINESS_PARTNER" />;
}